import { isPast } from "date-fns";

import type { BillingQuery } from "~/graphql/graphql-new.gen";
import { StoreRegion } from "~/graphql/graphql.gen";

import type { Brand } from "../stores/brand";
import { isInUE } from "./utils";

export const hasMissingBillingInformation = (brand: Brand) => {
  return (
    !brand?.billing_address ||
    (brand?.store === StoreRegion.Fr &&
      isInUE(brand.billing_address.countryCode) &&
      !brand.intracommunity_vat &&
      !brand.is_autoentrepreneur)
  );
};

export const hasBillingErrors = (
  billingError: unknown,
  billing: BillingQuery["billingV2"] | undefined,
) => {
  return Boolean(billingError) || Boolean(billing?.has_error);
};

export const hasSaleStarted = (startDate?: string) => {
  if (!startDate) return false;

  return isPast(new Date(startDate));
};

export const hasSaleEnded = (endDate?: string) => {
  if (!endDate) return false;

  return isPast(new Date(endDate));
};
